/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useDispatch } from 'react-redux';

import { clearPostPrefillFields } from 'state/creditApplication';
import Button, { ButtonProps } from 'components/Button';
import React, { useCallback } from 'react';

function SkipPrefillButton<C extends React.ElementType = 'button'>(
  props: ButtonProps<C>,
) {
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    dispatch(clearPostPrefillFields());
  }, [dispatch]);

  return <Button id="continue" variant="text" onClick={onClick} {...props} />;
}

export default SkipPrefillButton;
